import { Ristorante } from "orser-model/Ristorante";

export default class UserAuthenticated {
    private static instance: UserAuthenticated;

    ristoranteIdList: string[] = [];
    utenteRistoranteList: any[] = [];
    ristoranteList: Ristorante[] = [];
    selectedRistorante: Ristorante | undefined = undefined;
    abilitaModuloServizio: boolean = false;
    abilitaModuloChat: boolean = false;

    static getInstance(): UserAuthenticated {
        if (!UserAuthenticated.instance) {
            UserAuthenticated.instance = new UserAuthenticated();
        }
        return UserAuthenticated.instance;
    }

    setSelectedRistorante(ristoranteId: string) {
        this.selectedRistorante = this.ristoranteList.find(r => r.id === ristoranteId);
        this.abilitaModuloServizio = this.utenteRistoranteList.find((utenteRistorante) => utenteRistorante.ristoranteId === ristoranteId)?.abilitaModuloServizio || false;
        this.abilitaModuloChat = this.utenteRistoranteList.find((utenteRistorante) => utenteRistorante.ristoranteId === ristoranteId)?.abilitaModuloChat || false;
    }
}